import { useLocation, useNavigate } from 'react-router-dom';
import { CommonDraggableList } from '../../components/DraggableList';
import { FlashdealReorderDraggableComponent } from '../../components/DraggableList/DraggableItem/FlashdealReorderDraggableComponent';
import { Button } from '@mui/material';
import { BackButton } from '../../components/Buttons/BackButton';
import { FLASHDEALS_ROUTE } from '../../constants/routes';
import { IProduct } from '../../types/product';
import { useEffect, useState } from 'react';
import { CustomerAppService } from '../../api/services/customerAppService';
import { IUpdateProductsBySectionRequest } from '../../types/api/request/customerapprequest';
import { useDispatch } from 'react-redux';
import { setDisplayedProducts } from '../../store/Reducers/CustomerAppSlice';
import { showNotification } from '../../store/Reducers/NotificationSnackbarSlice';
import { showAlertDialog } from '../../store/Reducers/AlertDialogSlice';

export const FlashdealReorderSequence = () => {
  const location = useLocation();
  const data = location.state as IProduct[] | undefined;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [sequencedProducts, setSequencedProducts] = useState<IProduct[]>([]);

  const hasUnsavedChanges = sequencedProducts?.length > 0;

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!hasUnsavedChanges) return;

      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const handleBack = () => {
    if (hasUnsavedChanges) {
      dispatch(
        showAlertDialog({
          title: 'Wait!',
          description: 'You have unsaved changes. Are you sure you want to leave?',
          confirmText: 'Discard',
          cancelText: 'Cancel',
          onConfirm: () => {
            navigate(FLASHDEALS_ROUTE);
          },
        }),
      );
    } else {
      navigate(FLASHDEALS_ROUTE);
    }
  };

  const onClickSave = async () => {
    try {
      const payload: IUpdateProductsBySectionRequest = {
        items: sequencedProducts?.map((x: IProduct, index) => {
          return {
            sequence: index + 1,
            sku: x.sKU,
          };
        }),
      };

      const data = await CustomerAppService.updateProductsBySection('flashdeals', payload);

      dispatch(setDisplayedProducts(data));

      dispatch(
        showNotification({
          message: `Successfully updated Flashdeals.`,
        }),
      );

      setSequencedProducts([]);
    } catch (err: any) {
      dispatch(
        showNotification({
          message: `Failed to update Flashdeals. ${err?.response?.data?.message || ''}`,
          severity: 'error',
        }),
      );
    }
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <BackButton onClick={handleBack} />
        <span style={{ fontSize: 12 }}>Back to Flash Deals</span>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: 20,
          alignItems: 'center',
        }}
      >
        <div>
          <div>This is where you can reorder the sequence of flash deals products.</div>
          <div>Don't forget to save your changes.</div>
        </div>

        <Button
          variant="contained"
          onClick={() => {
            onClickSave();
          }}
          disabled={!sequencedProducts?.length}
        >
          Save
        </Button>
      </div>

      <CommonDraggableList
        data={data}
        keyIdentifier="iD"
        DraggableComponent={FlashdealReorderDraggableComponent}
        onChangeSequence={(updatedSequence: []) => {
          setSequencedProducts(updatedSequence as IProduct[]);
        }}
      />
    </>
  );
};
